module.exports = __webpack_public_path__ + "img/ico-check-mark-success.6d434135.svg";